import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { ConnectedRouter } from 'connected-react-router';

import initializeFirebase from 'utils/firebase';

import 'normalize.css';
import './global.css';

import store, { history } from 'store';
import routes from 'routes';

initializeFirebase();

const container = document.getElementById('app');

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>{renderRoutes(routes)}</ConnectedRouter>
    </Provider>,
);
